import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useUID } from 'dibs-uid';
import { getSrcString, getSrcSetString } from '../helpers/getSrcStrings';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import { slugify } from '../../favorites/components/FavoriteFolders/helpers/slugify';

import styles from './HpRespFeaturedModuleItem.scss';

function HpRespFeaturedModuleItem({ item, onClick }) {
    const uid = useUID() || undefined;
    const { title = '', linkData, imageUrl, cta } = item || {};
    const linkId = slugify(`${item.title}-${uid}`);
    return (
        <div className={classnames(styles.item, 'colXs6')}>
            <SeoLink className={styles.link} linkData={linkData} onClick={onClick}>
                <span id={linkId} className={styles.title}>
                    {title}
                </span>
                <img
                    className={styles.image}
                    aria-labelledby={title ? linkId : undefined}
                    src={getSrcString({ url: imageUrl })}
                    srcSet={getSrcSetString({ url: imageUrl, widths: [100, 120, 150] })}
                />
                <span className={styles.cta}>{cta}</span>
            </SeoLink>
        </div>
    );
}

HpRespFeaturedModuleItem.propTypes = {
    item: PropTypes.shape({
        imageUrl: PropTypes.string,
        cta: PropTypes.string,
        title: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    onClick: PropTypes.func,
};

HpRespFeaturedModuleItem.defaultProps = {
    onClick: () => {},
};

export { HpRespFeaturedModuleItem };
